(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["wt-all-products"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('wt-bedding-catalog')) {
  customElements.define('wt-bedding-catalog', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const cards = [...this.querySelectorAll('[data-card]')];
      const groups = [...this.querySelectorAll('[data-group]')];
      const search = this.querySelector('[data-search]');
      const stock = this.querySelector('[data-stock]');
      const sort = this.querySelector('[data-sort]');
      const sortedGroup = this.querySelector('[data-sorted-group]');
      const sortedGrid = this.querySelector('[data-sorted-grid]');
      const buttons = [...this.querySelectorAll('[data-category]')];
      const sortedHeading = sortedGroup.querySelector('h2');
      const allHeading = sortedHeading.textContent;
      let category = 'all';
      const update = () => {
        const query = search.value.trim().toLocaleLowerCase();
        let shown = cards.filter(card => (category === 'all' || card.dataset.origin === category) && (!stock.checked || card.dataset.available === 'true') && card.dataset.searchText.toLocaleLowerCase().includes(query));
        const visible = new Set(shown);
        cards.forEach(card => { card.hidden = !visible.has(card); });
        if (sort.value === 'featured') {
          sortedGroup.hidden = true;
          groups.forEach(group => {
            const members = cards.filter(card => card.dataset.origin === group.dataset.group);
            const grid = group.querySelector('.wt-product-grid');
            members.forEach(card => grid.appendChild(card));
            const count = members.filter(card => visible.has(card)).length;
            group.hidden = count === 0;
            group.querySelector('[data-group-count]').textContent = String(count).padStart(2, '0');
          });
        } else {
          groups.forEach(group => { group.hidden = true; });
          sortedHeading.textContent = category === 'all' ? allHeading : groups.find(group => group.dataset.group === category).querySelector('h2').firstChild.textContent;
          if (sort.value === 'title-ascending') shown.sort((a, b) => a.dataset.title.localeCompare(b.dataset.title, document.documentElement.lang || undefined));
          else shown.sort((a, b) => (Number(a.dataset.price) - Number(b.dataset.price)) * (sort.value === 'price-descending' ? -1 : 1));
          shown.forEach(card => sortedGrid.appendChild(card));
          sortedGroup.hidden = shown.length === 0;
        }
        this.querySelector('[data-result-count]').textContent = String(shown.length);
        this.querySelector('[data-empty]').hidden = shown.length !== 0;
        buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.category === category)));
      };
      buttons.forEach(button => button.addEventListener('click', () => { category = button.dataset.category; update(); }));
      search.addEventListener('input', update);
      stock.addEventListener('change', update);
      sort.addEventListener('change', update);
      this.querySelector('[data-reset]').addEventListener('click', () => { category = 'all'; search.value = ''; stock.checked = false; sort.value = 'featured'; update(); search.focus(); });
      this.querySelectorAll('[data-wt-controls]').forEach(control => { control.hidden = false; });
      update();
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wt-announcement-bar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('wt-announcement')) {
    customElements.define('wt-announcement', class extends HTMLElement {
      connectedCallback() {
        this.frame = requestAnimationFrame(() => this.initialize());
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        this.events?.abort();
        this.sizeObserver?.disconnect();
        clearInterval(this.clock);
        clearTimeout(this.rotation);
      }
      initialize() {
        this.events?.abort();
        clearInterval(this.clock);
        clearTimeout(this.rotation);
        this.events = new AbortController();
        this.sizeObserver?.disconnect();
        this.sizeObserver = new ResizeObserver(() => this.updateHeight());
        this.sizeObserver.observe(this);
        this.slides = [...this.querySelectorAll('[data-notice-slide]')];
        this.liveSlides = [...this.slides];
        this.current = this.slides[0];
        this.designMode = Boolean(window.Shopify?.designMode);
        this.paused = matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.autoplay = this.dataset.autoplay === 'true';
        this.hovered = false;
        this.focused = false;
        this.editorSelected = false;
        this.dismissed = false;
        this.storageKey = 'wt-notice:' + this.dataset.sectionId + ':' + JSON.stringify(this.slides.map(slide => [slide.textContent.trim(), slide.dataset.deadline, slide.querySelector('a')?.getAttribute('href'), slide.dataset.expiryAction, slide.dataset.expiredText]));
        const listen = (target, event, callback) => target.addEventListener(event, callback, { signal: this.events.signal });
        try {
          this.dismissed = !this.designMode && this.dataset.rememberDismissal === 'true' && sessionStorage.getItem(this.storageKey) === '1';
        } catch {}
        listen(this, 'click', event => {
          const button = event.target.closest('button');
          if (!button || !this.contains(button)) return;
          if (button.hasAttribute('data-notice-step')) this.step(Number(button.dataset.noticeStep));
          if (button.hasAttribute('data-notice-close') && !this.designMode) {
            this.dismissed = true;
            this.hidden = true;
            clearTimeout(this.rotation);
            clearInterval(this.clock);
            try { if (this.dataset.rememberDismissal === 'true') sessionStorage.setItem(this.storageKey, '1'); } catch {}
          }
          if (button.hasAttribute('data-copy-code')) this.copyCode(button);
        });
        listen(this, 'keydown', event => {
          if (event.target !== this && !event.target.matches('[data-notice-step]')) return;
          if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
            event.preventDefault();
            const rtl = getComputedStyle(this).direction === 'rtl';
            this.step((event.key === 'ArrowRight' ? 1 : -1) * (rtl ? -1 : 1));
          }
        });
        listen(this, 'mouseenter', () => { this.hovered = true; this.schedule(); });
        listen(this, 'mouseleave', () => { this.hovered = false; this.schedule(); });
        listen(this, 'focusin', () => { this.focused = true; this.schedule(); });
        listen(this, 'focusout', () => queueMicrotask(() => { this.focused = this.contains(document.activeElement); this.schedule(); }));
        listen(document, 'visibilitychange', () => { this.tick(); this.schedule(); });
        listen(document, 'shopify:block:select', event => {
          const slide = this.slides.find(item => item.dataset.blockId === event.detail?.blockId);
          if (!slide) return;
          this.editorSelected = true;
          this.show(slide);
          this.schedule();
        });
        listen(document, 'shopify:block:deselect', event => {
          if (!this.slides.some(item => item.dataset.blockId === event.detail?.blockId)) return;
          this.editorSelected = false;
          this.schedule();
        });
        const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
        listen(reducedMotion, 'change', event => {
          if (event.matches) { this.paused = true; this.updateControls(); this.schedule(); }
        });
        this.tick();
        this.show(this.liveSlides[0]);
        this.clock = setInterval(() => this.tick(), 1000);
        this.schedule();
      }
      tick() {
        const now = Date.now();
        let changed = false;
        for (const slide of this.slides) {
          if (!slide.dataset.deadline || slide.dataset.expired === 'true') continue;
          const validFormat = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(?::\d{2})?(Z|[+-]\d{2}:\d{2})$/.test(slide.dataset.deadline);
          const deadline = validFormat ? Date.parse(slide.dataset.deadline) : NaN;
          if (!Number.isFinite(deadline)) continue;
          const remaining = Math.max(0, Math.floor((deadline - now) / 1000));
          if (deadline <= now && !this.designMode) {
            slide.dataset.expired = 'true';
            if (slide.dataset.expiryAction === 'hide') {
              slide.hidden = true;
              this.liveSlides = this.liveSlides.filter(item => item !== slide);
            } else {
              const text = document.createElement('span');
              text.className = 'wt-notice__text';
              text.textContent = slide.dataset.expiredText;
              slide.querySelector('[data-notice-content]').replaceChildren(text);
            }
            changed = true;
            continue;
          }
          const timer = slide.querySelector('[data-notice-countdown]');
          if (!timer) continue;
          const values = { days: Math.floor(remaining / 86400), hours: Math.floor(remaining / 3600) % 24, minutes: Math.floor(remaining / 60) % 60, seconds: remaining % 60 };
          for (const [unit, value] of Object.entries(values)) timer.querySelector('[data-time="' + unit + '"]').textContent = String(value).padStart(2, '0');
          timer.hidden = false;
        }
        if (changed) {
          const focusWasInCurrent = this.current?.contains(document.activeElement);
          if (!this.liveSlides.includes(this.current)) this.show(this.liveSlides[0]);
          this.updateControls();
          this.schedule();
          if (focusWasInCurrent && !this.hidden) this.querySelector('[data-notice-step]:not([hidden])')?.focus();
        }
      }
      show(slide) {
        this.current = slide;
        for (const item of this.slides) item.hidden = item !== slide;
        this.hidden = this.dismissed || !slide;
        this.updateControls();
      }
      step(direction) {
        if (this.liveSlides.length < 2) return;
        const index = this.liveSlides.indexOf(this.current);
        this.show(this.liveSlides[(index + direction + this.liveSlides.length) % this.liveSlides.length]);
        this.schedule();
      }
      updateControls() {
        const multiple = this.liveSlides.length > 1;
        this.liveSlides.forEach((slide, index) => slide.setAttribute('aria-label', this.dataset.slideLabel.replace('%index%', index + 1).replace('%total%', this.liveSlides.length)));
        for (const button of this.querySelectorAll('[data-notice-step]')) button.hidden = !multiple;
        const close = this.querySelector('[data-notice-close]');
        if (close) close.hidden = this.designMode;
        this.toggleAttribute('data-has-utilities', Boolean(close && !close.hidden));
        this.querySelector('.wt-notice__slides').setAttribute('aria-live', this.autoplay && !this.paused ? 'off' : 'polite');
      }
      updateHeight() {
        const height = this.hidden ? 0 : Math.round(this.getBoundingClientRect().height);
        document.documentElement.style.setProperty('--wt-announcement-height', height + 'px');
        document.documentElement.style.setProperty('--wt-announcement-sticky-height', this.dataset.sticky === 'true' ? height + 'px' : '0px');
        this.dispatchEvent(new CustomEvent('wt:announcement:resize', { bubbles: true, detail: { height, sticky: this.dataset.sticky === 'true' } }));
      }
      schedule() {
        clearTimeout(this.rotation);
        if (!this.autoplay || this.paused || this.hovered || this.focused || this.editorSelected || this.hidden || document.hidden || this.liveSlides.length < 2) return;
        this.rotation = setTimeout(() => this.step(1), Math.max(5, Number(this.dataset.interval) || 7) * 1000);
      }
      async copyCode(button) {
        const code = button.dataset.copyCode;
        let success = false;
        try { await navigator.clipboard.writeText(code); success = true; } catch {
          const input = document.createElement('textarea');
          input.value = code;
          input.style.cssText = 'position:fixed;left:-9999px;top:0';
          document.body.append(input);
          input.select();
          try { success = document.execCommand('copy'); } catch {}
          input.remove();
          button.focus({ preventScroll: true });
        }
        this.querySelector('[data-notice-status]').textContent = success ? this.dataset.copiedLabel : this.dataset.copyFailedLabel + ' ' + code;
        if (success) {
          const label = button.querySelector('span');
          label.textContent = this.dataset.copiedLabel;
          setTimeout(() => { if (label.isConnected) label.textContent = code; }, 1800);
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wt-bamboo-purchase"] && !Shopify.designMode) return;
  try {
    function setupBambooPurchase(root){
 if(root.dataset.ready)return;root.dataset.ready='true';
 const data=JSON.parse(root.querySelector('[data-bb-data]').textContent),qs=s=>root.querySelector(s),all=s=>[...root.querySelectorAll(s)];
 let current=data.variants.find(v=>v.id===data.initial)||data.variants[0],selected=current.options.slice(),busy=false;
 const image=qs('[data-shop-image]'),qty=qs('[name=quantity]'),form=qs('form'),add=qs('[data-bb-add]');
 function normalize(){qty.value=String(Math.max(1,Math.min(99,Math.floor(Number(qty.value)||1))));qs('[data-bb-minus]').disabled=+qty.value<=1;qs('[data-bb-plus]').disabled=+qty.value>=99;}
 function photo(src,id){if(!src)return;image.src=src;all('[data-bb-image]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.bbImageId===String(id))));}
 function render(){
  current=data.variants.find(v=>v.options.every((x,i)=>x===selected[i]));
  all('[data-bb-option]').forEach(b=>{const i=+b.dataset.bbOption;const match=data.variants.find(v=>v.options.every((x,n)=>x===(n===i?b.dataset.bbValue:selected[n])));b.dataset.unavailable=String(!match||!match.available);b.setAttribute('aria-pressed',String(selected[i]===b.dataset.bbValue));});
  all('[data-bb-selected]').forEach(n=>n.textContent=selected[+n.dataset.bbSelected]);
  qs('[name=id]').value=current?.id||'';qs('[name=id]').disabled=!current;qs('[name=id]').dispatchEvent(new Event('change',{bubbles:true}));
  qs('[data-shop-price]').textContent=current?new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:data.currency||'USD'}).format(current.price/100):'—';
  add.disabled=busy||!current?.available;add.textContent=current?.available?data.labels.add:current?data.labels.sold:data.labels.missing;
  qs('[data-shop-status]').textContent=(current?.available?data.labels.available:current?data.labels.sold:data.labels.missing)+' · '+selected.join(' / ');
  const payment=qs('.bbNativePayments');if(payment)payment.hidden=!current?.available;
  if(current){photo(current.image,current.imageId);const u=new URL(location.href);u.searchParams.set('variant',current.id);history.replaceState({},'',u);}
 }
 root.addEventListener('click',e=>{
  const b=e.target.closest('button');if(!b)return;
  if(b.matches('[data-bb-option]')){selected[+b.dataset.bbOption]=b.dataset.bbValue;render();}
  if(b.matches('[data-bb-image]')){photo(b.dataset.bbImage,b.dataset.bbImageId);}
  if(b.matches('[data-bb-minus],[data-bb-plus]')){qty.value=+qty.value+(b.hasAttribute('data-bb-plus')?1:-1);normalize();}
  if(b.matches('[data-bb-zoom]')){const box=qs('[data-bb-lightbox]');box.querySelector('img').src=image.src;box.showModal();}
  if(b.matches('[data-bb-close]'))b.closest('dialog').close();
 });
 qty.addEventListener('change',normalize);
 form.addEventListener('submit',async e=>{
  e.preventDefault();e.stopPropagation();if(busy||!current?.available)return;normalize();busy=true;add.disabled=true;add.setAttribute('aria-busy','true');
  const error=qs('[data-bb-error]'),status=qs('[data-bb-success]');error.hidden=true;status.hidden=true;
  let added=false;
  try{const response=await fetch((window.Shopify?.routes?.root||'/')+'cart/add.js',{method:'POST',body:new FormData(form),headers:{Accept:'application/json'}});const result=await response.json();if(!response.ok)throw new Error(typeof result.description==='string'?result.description:data.labels.error);added=true;status.textContent=data.labels.added;status.hidden=false;
   for(let i=0;i<20&&typeof window.corner?.do!=='function';i++)await new Promise(r=>setTimeout(r,150));
   if(typeof window.corner?.do==='function'){await window.corner.do('refreshCart');await window.corner.do('openCart');}
  }catch(err){if(!added){error.textContent=err.message||data.labels.error;error.hidden=false;}}
  finally{busy=false;add.removeAttribute('aria-busy');render();}
 });render();normalize();
}
function initBambooPurchases(scope=document){scope.querySelectorAll('[data-bamboo-purchase]').forEach(setupBambooPurchase);}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>initBambooPurchases());else initBambooPurchases();
document.addEventListener('shopify:section:load',e=>initBambooPurchases(e.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wt-bamboo-story"] && !Shopify.designMode) return;
  try {
    function initBambooStory(scope=document){scope.querySelectorAll('[data-bamboo-story]').forEach(root=>{if(root.dataset.ready)return;root.dataset.ready='true';root.addEventListener('click',e=>{const top=e.target.closest('[data-bamboo-top]');if(top){e.preventDefault();document.getElementById('bb-shop')?.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'});return;}const b=e.target.closest('[data-bamboo-color]');if(!b)return;root.querySelectorAll('[data-bamboo-color]').forEach(x=>x.setAttribute('aria-pressed',String(x===b)));const img=root.querySelector('[data-bamboo-preview]');if(img){img.src=b.dataset.image;img.alt=b.dataset.alt;}root.querySelector('[data-bamboo-name]').textContent=b.dataset.bambooColor;root.querySelector('[data-bamboo-mood]').textContent=b.dataset.mood;});});}if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>initBambooStory());else initBambooStory();document.addEventListener('shopify:section:load',e=>initBambooStory(e.target));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wt-duvet-shop"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('wt-duvet-product')) {
    customElements.define('wt-duvet-product', class extends HTMLElement {});
  }

  document.addEventListener('click', function (event) {
    const swatch = event.target.closest('[data-color-swatch]');
    if (!swatch) return;
    const card = swatch.closest('[data-duvet-product]');
    if (!card) return;

    card.querySelectorAll('[data-color-swatch]').forEach(function (button) {
      const selected = button === swatch;
      button.classList.toggle('is-selected', selected);
      button.setAttribute('aria-pressed', selected ? 'true' : 'false');
    });

    const price = card.querySelector('[data-product-price]');
    const colorName = card.querySelector('[data-color-name]');
    const image = card.querySelector('[data-product-image]');
    const mediaLink = card.querySelector('[data-product-media-link]');
    const productLink = card.querySelector('[data-product-link]');

    if (price) price.innerHTML = swatch.dataset.price;
    if (colorName) colorName.textContent = swatch.dataset.colorName;
    if (image && swatch.dataset.image) {
      image.src = swatch.dataset.image;
      image.srcset = swatch.dataset.srcset;
      image.alt = image.alt.replace(/ in .+$/, '') + ' in ' + swatch.dataset.colorName;
    }
    if (mediaLink) mediaLink.href = swatch.dataset.url;
    if (productLink) productLink.href = swatch.dataset.url;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wt-gift-card"] && !Shopify.designMode) return;
  try {
    
(() => {
  const boot = (scope = document) => {
    scope.querySelectorAll('[data-wtgc]').forEach(root => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const form = root.querySelector('form');
      const button = root.querySelector('[data-gift-add]');
      const label = root.querySelector('[data-add-label]');
      const status = root.querySelector('[data-gift-status]');
      const strings = JSON.parse(root.querySelector('[data-gift-strings]').textContent);
      const originalLabel = label.textContent;
      root.querySelectorAll('[data-gallery-variant]').forEach(thumb => thumb.addEventListener('click', () => {
        const input = form.querySelector('input[name="id"][value="' + thumb.dataset.galleryVariant + '"]');
        input?.click();
      }));
      form.addEventListener('change', event => {
        if (event.target.name !== 'id') return;
        const selected = event.target;
        root.querySelector('[data-gift-price]').textContent = selected.dataset.price;
        const pay = root.querySelector('[data-pay-price]');
        if (pay) pay.textContent = selected.dataset.pay;
        const face = root.querySelector('[data-face-price]');
        if (face) face.textContent = selected.dataset.face;
        const saving = root.querySelector('[data-save-price]');
        if (saving) saving.textContent = selected.dataset.saving;
        root.querySelector('[data-button-price]').textContent = selected.dataset.amountLabel;
        button.disabled = selected.disabled;
        const picture = root.querySelector('[data-gift-image]');
        if (picture && selected.dataset.image) { picture.src = selected.dataset.image; picture.alt = selected.dataset.imageAlt; }
        root.querySelectorAll('[data-gallery-variant]').forEach(thumb => thumb.setAttribute('aria-pressed', String(thumb.dataset.galleryVariant === selected.value)));
        const url = new URL(location.href);
        url.searchParams.set('variant', selected.value);
        history.replaceState({}, '', url);
        status.hidden = true;
      });
      form.addEventListener('submit', async event => {
        if (event.submitter && !event.submitter.matches('[data-gift-add]')) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        if (button.disabled) return;
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        label.textContent = strings.adding;
        status.hidden = true;
        status.removeAttribute('data-error');
        try {
          const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {method:'POST', headers:{Accept:'application/json'}, body:new FormData(form)});
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || strings.error);
          status.textContent = strings.added;
          status.hidden = false;
          if (window.corner?.do) {
            await window.corner.do('refreshCart');
            await window.corner.do('openCart');
          } else if (window.WTCart) {
            await window.WTCart.refresh();
            await window.WTCart.open();
          } else {
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            document.querySelector('[data-ajax-cart-trigger]')?.click();
          }
        } catch (error) {
          status.textContent = error.message || strings.error;
          status.dataset.error = 'true';
          status.hidden = false;
        } finally {
          button.disabled = false;
          button.removeAttribute('aria-busy');
          label.textContent = originalLabel;
        }
      });
    });
  };
  boot();
  document.addEventListener('shopify:section:load', event => boot(event.target));
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wt-sateen-purchase"] && !Shopify.designMode) return;
  try {
    
function bindSateenPurchase(root) {
  if (!root || root.dataset.ready) return () => {};
  const variants = JSON.parse(root.querySelector('[data-purchase-variants]').textContent);
  const labels = JSON.parse(root.querySelector('[data-purchase-labels]').textContent);
  const form = root.querySelector('form');
  const select = root.querySelector('[data-variant-select]');
  const quantity = root.querySelector('[name="quantity"]');
  const submit = root.querySelector('[data-purchase-submit]');
  const image = root.querySelector('[data-purchase-image]');
  const radios = [...root.querySelectorAll('[data-option-position]')];
  const getVariant = () => variants.find(v => String(v.id) === select.value);
  const setOptions = variant => radios.forEach(input => { input.checked = input.value === variant.options[Number(input.dataset.optionPosition)]; });
  function update(variant, updateUrl = true) {
    select.value = variant ? String(variant.id) : '';
    root.querySelector('[data-purchase-price]').textContent = variant ? variant.priceText : labels.unavailable;
    const compare = root.querySelector('[data-purchase-compare]');
    compare.textContent = variant?.compareText || '';
    compare.hidden = !variant?.compareText;
    const available = Boolean(variant?.available && !variant.requiresSellingPlan);
    submit.disabled = !available;
    submit.textContent = !variant ? labels.unavailable : variant.requiresSellingPlan ? labels.optionsRequired : available ? labels.add : labels.soldOut;
    root.querySelector('[data-purchase-status]').textContent = available ? labels.available : variant ? (variant.requiresSellingPlan ? labels.optionsRequired : labels.soldOut) : labels.unavailable;
    root.querySelector('[data-purchase-status]').dataset.available = String(available);
    if (variant?.image) { image.src = variant.image; image.removeAttribute('srcset'); image.alt = variant.imageAlt; }
    if (variant) {
      const rules = variant.quantityRule || { min: 1, increment: 1 };
      quantity.min = String(rules.min || 1); quantity.step = String(rules.increment || 1);
      if (rules.max != null) quantity.max = String(rules.max); else quantity.removeAttribute('max');
      let n = Number(quantity.value);
      if (!Number.isSafeInteger(n) || n < Number(quantity.min) || (n - Number(quantity.min)) % Number(quantity.step)) n = Number(quantity.min);
      if (rules.max != null) n = Math.min(n, rules.max);
      quantity.value = String(n);
      root.querySelectorAll('[data-chosen-option]').forEach(el => { el.textContent = variant.options[Number(el.dataset.chosenOption)]; });
      const color = variant.options[1];
      const lower = document.querySelector(`.wtSateen [data-sateen-color="${CSS.escape(color)}"]`);
      if (lower) {
        document.querySelectorAll('.wtSateen [data-sateen-color]').forEach(el => el.setAttribute('aria-pressed', String(el === lower)));
        const lowerImage = document.querySelector('[data-sateen-preview]');
        if (lowerImage) { lowerImage.src = lower.dataset.image; lowerImage.alt = lower.dataset.alt; }
        const name = document.querySelector('[data-sateen-name]'); if (name) name.textContent = color;
        const mood = document.querySelector('[data-sateen-mood]'); if (mood) mood.textContent = lower.dataset.mood;
      }
      if (updateUrl && /^https?:$/.test(location.protocol)) { const url = new URL(location.href); url.searchParams.set('variant', String(variant.id)); history.replaceState(null, '', url); }
    }
    radios.forEach(input => {
      const selected = [...root.querySelectorAll('[data-option-position]:checked')].sort((a,b) => Number(a.dataset.optionPosition)-Number(b.dataset.optionPosition)).map(i => i.value);
      selected[Number(input.dataset.optionPosition)] = input.value;
      const match = variants.find(v => v.options.every((option,i) => option === selected[i]));
      input.closest('label').classList.toggle('spUnavailable', !match?.available);
      input.closest('label').title = match?.available ? input.value : `${input.value} — ${labels.soldOut}`;
    });
    root.querySelector('[data-quantity-minus]').disabled = Number(quantity.value) <= Number(quantity.min);
    root.querySelector('[data-quantity-plus]').disabled = quantity.hasAttribute('max') && Number(quantity.value) >= Number(quantity.max);
  }
  function change(event) {
    if (event.target.matches('[data-option-position]')) {
      const values = [...root.querySelectorAll('[data-option-position]:checked')].sort((a,b) => Number(a.dataset.optionPosition)-Number(b.dataset.optionPosition)).map(i => i.value);
      update(variants.find(v => v.options.every((value,i) => value === values[i])));
    } else if (event.target === quantity) { update(getVariant(), false); } else if (event.target === select) { const v = getVariant(); if (v) { setOptions(v); update(v); } }
  }
  function click(event) {
    const thumb = event.target.closest('[data-gallery-image]');
    if (thumb) { image.src = thumb.dataset.galleryImage; image.removeAttribute('srcset'); image.alt = thumb.dataset.galleryAlt; return; }
    const step = event.target.closest('[data-quantity-step]');
    if (step) { if (Number(step.dataset.quantityStep) > 0) quantity.stepUp(); else quantity.stepDown(); update(getVariant(), false); }
  }
  function validate(event) {
    const v = getVariant();
    if (!v?.available || v.requiresSellingPlan || !quantity.checkValidity() || !Number.isSafeInteger(Number(quantity.value))) {
      event.preventDefault(); quantity.reportValidity(); root.querySelector('[data-purchase-status]').textContent = !v?.available ? labels.soldOut : labels.checkQuantity;
    }
  }
  function external(event) {
    const button = event.target.closest('[data-sateen-color]');
    if (!button) return;
    const colorInput = radios.find(input => Number(input.dataset.optionPosition) === 1 && input.value === button.dataset.sateenColor);
    if (colorInput) { colorInput.checked = true; colorInput.dispatchEvent(new Event('change', { bubbles: true })); }
  }
  const requested = variants.find(v => String(v.id) === new URLSearchParams(location.search).get('variant'));
  const initial = requested || getVariant() || variants.find(v => v.available) || variants[0];
  if (initial) { setOptions(initial); update(initial, false); }
  root.dataset.ready = 'true';
  root.addEventListener('change', change); root.addEventListener('click', click); form.addEventListener('submit', validate); document.addEventListener('click', external);
  return () => { delete root.dataset.ready; root.removeEventListener('change', change); root.removeEventListener('click', click); form.removeEventListener('submit', validate); document.removeEventListener('click', external); };
}

const sateenCleanup = new Map();
function setupSateenPurchases() {
  document.querySelectorAll('[data-sateen-purchase]').forEach(root => { if (!sateenCleanup.has(root)) sateenCleanup.set(root, bindSateenPurchase(root)); });
}
document.addEventListener('shopify:section:unload', event => { for (const [root, cleanup] of sateenCleanup) { if (event.target.contains(root)) { cleanup(); sateenCleanup.delete(root); } } });
if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", setupSateenPurchases); else setupSateenPurchases();
document.addEventListener("shopify:section:load", setupSateenPurchases);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wt-sheets-comforters"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',function(event){const button=event.target.closest('[data-sheet-scroll]');if(!button)return;const track=document.getElementById(button.getAttribute('aria-controls'));if(!track)return;const card=track.querySelector('.comforter-card');track.scrollBy({left:Number(button.dataset.sheetScroll)*(card.getBoundingClientRect().width+14),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wt-sheets-product"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',function(event){const swatch=event.target.closest('[data-sheet-swatch]');if(!swatch||event.ctrlKey||event.metaKey||event.shiftKey||event.altKey)return;const card=swatch.closest('[data-sheet-product]');const image=card.querySelector('.sheet-product-image');if(!image||!swatch.dataset.image)return;event.preventDefault();image.removeAttribute('srcset');image.src=swatch.dataset.image;image.alt=swatch.dataset.alt;card.querySelectorAll('[data-sheet-color]').forEach(el=>el.textContent=swatch.dataset.name);card.querySelectorAll('[data-sheet-swatch]').forEach(el=>{el.classList.toggle('selected',el===swatch);if(el===swatch)el.setAttribute('aria-current','true');else el.removeAttribute('aria-current');});card.querySelector('[data-sheet-cta]').href=swatch.href;});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wt-tencel-purchase"] && !Shopify.designMode) return;
  try {
    
function setupWtTencelPurchase(root) {
  if (!root || root.dataset.ready) return () => {};
  root.dataset.ready = 'true';
  const abort = new AbortController();
  const on = (target, event, fn) => target?.addEventListener(event, fn, {signal: abort.signal});

  const data = JSON.parse(root.querySelector('[data-wp-data]').textContent);
  const variants = data.variants;
  const qs = s => root.querySelector(s);
  const all = s => [...root.querySelectorAll(s)];
  const money = n => new Intl.NumberFormat('en-US', {style:'currency', currency:data.currency || 'USD'}).format(n/100);
  const urlId = new URLSearchParams(location.search).get('variant');
  let variant = variants.find(v => String(v.id) === urlId) || variants.find(v => v.id === data.initial) || variants[0];
  let selected = variant.options.slice();
  const qty = qs('[name=quantity]');
  const img = qs('[data-wp-main]');
  const thumbs = all('[data-wp-image]');
  const showImage = (src, alt) => {
    img.src = src; img.alt = alt;
    thumbs.forEach(b => b.setAttribute('aria-pressed', String(b.dataset.wpImage === src)));
    const active = thumbs.find(b => b.dataset.wpImage === src);
    const rail = qs('.wpThumbs');
    if (active && rail) {
      const item = active.getBoundingClientRect(), frame = rail.getBoundingClientRect();
      if (item.left < frame.left) rail.scrollTo({left:rail.scrollLeft + item.left - frame.left,behavior:'smooth'});
      else if (item.right > frame.right) rail.scrollTo({left:rail.scrollLeft + item.right - frame.right,behavior:'smooth'});
    }
  };
  const normalize = () => {
    qty.value = String(Math.max(1, Math.min(99, Math.floor(Number(qty.value) || 1))));
    qs('[data-wp-minus]').disabled = +qty.value <= 1;
    qs('[data-wp-plus]').disabled = +qty.value >= 99;
  };
  let adding = false;
  const render = () => {
    variant = variants.find(v => v.options.every((o,i) => o === selected[i]));
    all('[data-wp-option]').forEach(b => {
      const index = +b.dataset.wpOption;
      const value = b.dataset.value;
      const exists = variants.some(v => v.options[index] === value && (index === 0 || v.options[0] === selected[0]));
      b.disabled = !exists;
      b.setAttribute('aria-pressed', String(selected[index] === value));
      b.title = exists ? value : data.labels.unavailable;
    });
    all('[data-wp-selected]').forEach(el => {el.textContent = selected[+el.dataset.wpSelected] || '';});
    const variantInput = qs('[name=id]');
    variantInput.value = variant?.id || '';
    variantInput.dispatchEvent(new Event('change', {bubbles:true}));
    qs('[data-wp-price]').textContent = variant ? money(variant.price) : data.labels.unavailable;
    const compare = variant?.compare_at_price || 0;
    const discounted = !!variant && compare > variant.price;
    qs('[data-wp-compare]').hidden = !discounted;
    qs('[data-wp-saving]').hidden = !discounted;
    const saleBadge = qs('[data-wp-sale]');
    if (saleBadge) saleBadge.hidden = !discounted || saleBadge.dataset.enabled !== 'true' || !saleBadge.textContent.trim();
    if (discounted) {
      qs('[data-wp-compare]').textContent = money(compare);
      qs('[data-wp-saving]').textContent = data.labels.save_label+' '+money(compare-variant.price)+' · '+Math.round(100*(compare-variant.price)/compare)+'% '+data.labels.off_label;
    }
    const available = !!variant?.available;
    qs('[data-wp-add]').disabled = adding || !available;
    qs('[data-wp-add]').textContent = adding ? (data.labels.add_to_cart + '…') : available ? data.labels.add_to_cart : variant ? data.labels.sold_out : data.labels.unavailable;
    const payment = qs('[data-wp-payment]');
    if (payment) {payment.disabled = !available; payment.hidden = !available;}
    qs('[data-wp-stock]').textContent = available ? data.labels.in_stock : variant ? data.labels.sold_out : data.labels.unavailable;
    if (variant?.image) showImage(variant.image, data.title+' — '+variant.options.join(' / '));
  };
  const selectTab = b => {
    all('[data-wp-tab]').forEach(t => {
      const active = t === b;
      t.setAttribute('aria-selected',String(active)); t.tabIndex = active ? 0 : -1;
      qs('#'+t.getAttribute('aria-controls')).hidden = !active;
    });
  };
  on(root, 'click', e => {
    const button = e.target.closest('button');
    if (!button) return;
    if (button.matches('[data-wp-option]')) {
      const i = +button.dataset.wpOption;
      selected[i] = button.dataset.value;
      let match = variants.find(v => v.options.every((o,n) => o === selected[n]));
      if (!match && i === 0) {
        match = variants.find(v => v.options[0] === selected[0] && v.available) || variants.find(v => v.options[0] === selected[0]);
        if (match) {
          selected = match.options.slice();
          qs('[data-wp-announcement]').textContent = selected.join(' / ');
        }
      } else qs('[data-wp-announcement]').textContent = selected.join(' / ');
      render();
      if (variant) { const url=new URL(location.href); url.searchParams.set("variant",variant.id); history.replaceState({},"",url); }
    }
    if (button.matches('[data-wp-image]')) showImage(button.dataset.wpImage,button.dataset.wpAlt);
    if (button.matches('[data-wp-step]')) {
      const current = Math.max(0,thumbs.findIndex(b => b.getAttribute('aria-pressed') === 'true'));
      const next = thumbs[(current + +button.dataset.wpStep + thumbs.length)%thumbs.length];
      showImage(next.dataset.wpImage,next.dataset.wpAlt);
    }
    if (button.matches('[data-wp-zoom]')) {
      const box=qs('[data-wp-lightbox]');box.querySelector('img').src=img.src;box.querySelector('img').alt=img.alt;box.showModal();
    }
    if (button.matches('[data-wp-close]')) button.closest('dialog').close();
    if (button.matches('[data-wp-minus],[data-wp-plus]')) {qty.value = +qty.value + (button.matches('[data-wp-plus]') ? 1 : -1);normalize();}
    if (button.matches('[data-wp-tab]')) selectTab(button);
  });
  on(qs('form'), 'submit', async e => {
    e.preventDefault();
    e.stopPropagation();
    if (adding || !variant?.available) return;
    normalize();
    const button = qs('[data-wp-add]');
    const error = qs('[data-wp-cart-error]');
    const status = qs('[data-wp-cart-status]');
    const payload = new FormData(e.currentTarget);
    adding = true;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    button.textContent = (data.labels.add_to_cart + '…');
    error.hidden = true;
    status.hidden = true;
    let added = false;
    try {
      const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {
        method: 'POST', body: payload, headers: {'Accept': 'application/json'}
      });
      const result = await response.json();
      if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : data.labels.add_error);
      added = true;
      status.textContent = data.labels.added_text;
      status.hidden = false;
      for (let attempt = 0; attempt < 20 && typeof window.corner?.do !== 'function'; attempt++) {
        await new Promise(resolve => setTimeout(resolve, 150));
      }
      if (typeof window.corner?.do === 'function') {
        await window.corner.do('refreshCart');
        await window.corner.do('openCart');
      }
    } catch (failure) {
      if (!added) {
        error.textContent = failure.message || data.labels.add_error;
        error.hidden = false;
      }
    } finally {
      adding = false;
      button.removeAttribute('aria-busy');
      button.disabled = !variant?.available;
      button.textContent = variant?.available ? data.labels.add_to_cart : variant ? data.labels.sold_out : data.labels.unavailable;
    }
  });
  on(qty,'change',normalize);
  on(qs('[role=tablist]'),'keydown',e => {
    const tabs=all('[data-wp-tab]'),index=tabs.indexOf(document.activeElement);if(index<0)return;
    let next;if(e.key==='ArrowRight')next=(index+1)%tabs.length;else if(e.key==='ArrowLeft')next=(index-1+tabs.length)%tabs.length;else if(e.key==='Home')next=0;else if(e.key==='End')next=tabs.length-1;else return;
    e.preventDefault();selectTab(tabs[next]);tabs[next].focus();
  });
  render();normalize();
  return () => {abort.abort();delete root.dataset.ready;};
}
function initWtTencelPurchases(scope=document) {
 scope.querySelectorAll('.wpProduct[data-product="tencel"]').forEach(root=>{root.wtCleanup=setupWtTencelPurchase(root);});
}
if (document.readyState==='loading') document.addEventListener('DOMContentLoaded',()=>initWtTencelPurchases()); else initWtTencelPurchases();
document.addEventListener('shopify:section:load',event=>initWtTencelPurchases(event.target));
document.addEventListener('shopify:section:unload',event=>event.target.querySelectorAll('.wpProduct').forEach(root=>root.wtCleanup?.()));


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wt-tencel-story"] && !Shopify.designMode) return;
  try {
    
(function () {
  function setup() {
    document.querySelectorAll('.wtTencel').forEach(function (root) {
      if (root.dataset.tencelReady) return;
      root.dataset.tencelReady = 'true';
      root.addEventListener('click', function (event) {
        if (event.target.closest('[data-tencel-top]')) {
          event.preventDefault();
          window.scrollTo({top: 0, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
          return;
        }
        var button = event.target.closest('[data-tencel-color]');
        if (!button) return;
        root.querySelectorAll('[data-tencel-color]').forEach(function (b) { b.setAttribute('aria-pressed', String(b === button)); });
        var img = root.querySelector('[data-tencel-preview]');
        img.src = button.dataset.image;
        img.alt = button.dataset.alt;
        root.querySelector('[data-tencel-name]').textContent = button.dataset.tencelColor;
        root.querySelector('[data-tencel-mood]').textContent = button.dataset.mood;
      });
    });
  }
  document.addEventListener('shopify:section:load', setup);
  document.addEventListener('shopify:block:select', function(e) { e.target.scrollIntoView({block:'center',behavior:'smooth'}); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup); else setup();
})();


  } catch(e) { console.error(e); }
})();
})();
